<template>
  <el-collapse-transition>
    <div v-show="isShow" class="menu" :style="myStyle" :class="{focus: focus}" @mousedown.stop>
      <div
        class="menu__main"
        :class="{disabled: disabled,'toggleStyle':this.focus}"
        @click="toggle()"
      >
        <div class="menu__display ellipsis">{{selectedItem ? selectedItem.name : all}}</div>
        <i class="triang"></i>
      </div>
      <transition name="el-zoom-in-top" @after-enter="optionsEnterDone">
        <div ref="options" class="menu__options" v-show="focus">
          <div v-bar>
            <div>
              <div
                class="menu__item"
                :class="{selected: selectedIndex === -1}"
                @click="clickItem(null, -1)"
              >{{all}}</div>
              <div
                class="menu__item ellipsis"
                v-for="(item, i) in options"
                :class="{selected: i === selectedIndex}"
                @click="clickItem(item, i)"
              >{{item.name}}</div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </el-collapse-transition>
</template>

<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      default: true
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    selectedIndex: {
      type: Number,
      default: -1
    },
    myStyle: {
      type: Object,
      default() {
        return {};
      }
    },
    all: {
      type: String,
      default: "全部"
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      focus: false
    };
  },
  computed: {
    selectedItem() {
      return this.options[this.selectedIndex] || null;
    }
  },
  watch: {
    focus(val) {
      val && this.$bus.emit("rightnav.dropDownMenu.expand");
      if (!val && this.memoryH) {
        let el = this.$refs.options;
        let container = $(el).closest(".body-list");
        container.css("min-height", 0);
      }
    }
  },
  mounted() {
    $("body").on("mousedown", () => {
      this.focus = false;
    });
  },
  methods: {
    toggle() {
      if (this.disabled) {
        return;
      }
      this.focus = !this.focus;
    },
    clickItem(item, i) {
      this.$emit("clickItem", i);
      this.focus = false;
    },
    optionsEnterDone() {
      let val = this.focus;
      if (val) {
        this.$nextTick(() => {
          let el = this.$refs.options;
          let container = $(el).closest(".body-list");
          if (!container.length) {
            return;
          }
          // let biggerHeight = container.prop('scrollHeight') + 10
          let biggerHeight = $(this.$el)
            .find(".menu__options")
            .css("height");
          biggerHeight = parseFloat(biggerHeight) + 30;
          if (container.height() < biggerHeight) {
            this.memoryH =
              ((container[0] || {}).style || {}).height || parseFloat(container.css("height"));
            container.css("min-height", biggerHeight);
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../style/_triangle";

.menu {
  position: relative;
  width: 270px;
  &__main {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 38px;
    border-radius: 8px;
    border: solid 1px #d9ddea;
    padding-left: 20px;
    padding-right: 12px;
    background-color: #fff;
    cursor: pointer;

    &.disabled {
      cursor: not-allowed;
    }

    &.disabled > * {
      opacity: 0.3;
    }

    &:hover {
      border-color: #5778fb;
    }
  }
  &__display {
    background-color: #fff;
  }
  .toggleStyle {
    border-color: #5778fb;
  }
  &__options {
    position: absolute;
    left: 0;
    top: calc(5px + 38px);
    background-color: #fff;
    border: 1px solid #f0f0f9;
    border-radius: 5px;
    width: 100%;
    max-height: 360px;
    & > div {
      max-height: 360px;
    }
    & > div > div {
      overflow: auto !important;
      // padding-bottom: 17px;
      max-height: 360px;
    }
  }
  &__item {
    line-height: 36px;
    color: #474261;
    text-align: left;
    padding-left: 20px;
    padding-right: 37px;
    cursor: pointer;
    &:hover {
      background: #f0f0f9;
    }
    &.selected {
      background: #f0f0f9;
    }
  }
}
.menu {
  .triang {
    // @include triangle(bottom, 6px, 8px, #000);
    width: 10px;
    height: 6px;
    background-image: url(../../../../static/svg/right-nav-new/arrow-down.svg);
    background-repeat: no-repeat;
    transition-duration: 0.3s;
  }
}
.menu.focus {
  .triang {
    transform: rotate(-180deg);
  }
}

.ellipsis {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/rightnav/controls/menu.vue